<kendo-dialog title="{{'FORCE-CLOSE-TASK' | translate}}: {{shortTaskName}}" *ngIf="dialogOpened"
  (close)="cancelForceClose()" [minWidth]="200" [width]="500">
  <div class="k-form p-2">    
    <label class="k-form-field">
      <span class="k-text-uppercase dark w-100">{{ 'FORCE-CLOSE-REASON' | translate }} *</span>
      <textarea kendoTextArea [autoSize]="true" required class="w-100 k-textarea" rows="2"
        [(ngModel)]="reason" id="reason" maxlength="512">
      </textarea>
    </label>
  </div>
  <div>* {{'REQUIRED-FIELDS' | translate}}</div>
  <kendo-dialog-actions>
    <button kendoButton (click)="cancelForceClose()">{{ 'CANCEL' | translate }}</button>
    <button appPreventClick kendoButton (click)="forceClose();" [primary]="true"
      [disabled]="reason === ''">
      {{'SAVE' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>